import React from 'react';
import PropTypes from 'prop-types';
import { FilterSections } from '../../../../constants/filter/filter_sections';
import { Section } from './lightbox_overview/section';
import { LightboxOverview } from './lightbox_overview';
import { FilterSectionLabelTranslationKeys }
    from '../../../../constants/filter/filter_section_label_translation_keys';
import { types as productTypes } from '../../../../../_constants/product/types';

function LightboxOverviewTyre(props) {
    const isRegoLookupOrVehicleConfigurator = ['rego_lookup', 'vehicle_configurator']
        .indexOf(props.lastUsedConfigurator) >= 0;
    const customerReviewsEnabled = TYROOLA.initialFluxStates?.catalogFilter?.customerReviewsEnabled || false;

    return (
        <LightboxOverview
            openView={props.openView}
            onApplyClick={props.onApplyClick}
            onResetAndCloseClick={props.onResetAndCloseClick}
            opened={props.opened}
            filterValues={props.filterValues}
            filterOptions={props.filterOptions}
            onUnsetFilter={props.onUnsetFilter}
            productType={productTypes.TYRE_CAR}
            lastUsedConfigurator={props.lastUsedConfigurator}
            displayDimensions={props.displayDimensions}
        >
            {!isRegoLookupOrVehicleConfigurator &&
                <Section
                    sectionType={FilterSections.TYRE_INDEX_VIEW}
                    sectionName="index"
                    openView={props.openView}
                    translationKey={FilterSectionLabelTranslationKeys[FilterSections.TYRE_INDEX_VIEW]}
                />
            }

            {isRegoLookupOrVehicleConfigurator &&
                <Section
                    sectionType={FilterSections.FITMENT_VIEW}
                    sectionName="fitments"
                    openView={props.openView}
                    translationKey={FilterSectionLabelTranslationKeys[FilterSections.FITMENT_VIEW]}
                />
            }
            <Section
                sectionType={FilterSections.BRAND_VIEW}
                sectionName="brand"
                openView={props.openView}
                translationKey={FilterSectionLabelTranslationKeys[FilterSections.BRAND_VIEW]}
            />

            <Section
                sectionType={FilterSections.PRICE_VIEW}
                sectionName="price"
                openView={props.openView}
                translationKey={FilterSectionLabelTranslationKeys[FilterSections.PRICE_VIEW]}
            />

            <Section
                sectionType={FilterSections.DEALS_VIEW}
                sectionName="deals"
                openView={props.openView}
                translationKey={FilterSectionLabelTranslationKeys[FilterSections.DEALS_VIEW]}
            />

            <Section
                sectionType={FilterSections.FEATURES_VIEW}
                sectionName="features"
                openView={props.openView}
                translationKey={FilterSectionLabelTranslationKeys[FilterSections.FEATURES_VIEW]}
            />

            <Section
                sectionType={FilterSections.QUALITY_SEGMENT_VIEW}
                sectionName="quality_segments"
                openView={props.openView}
                translationKey={FilterSectionLabelTranslationKeys[FilterSections.QUALITY_SEGMENT_VIEW]}
            />

            {
                customerReviewsEnabled && <Section
                    sectionType={FilterSections.CUSTOMER_REVIEWS_VIEW}
                    sectionName="customer_reviews"
                    openView={props.openView}
                    translationKey={FilterSectionLabelTranslationKeys[FilterSections.CUSTOMER_REVIEWS_VIEW]}
                />
            }

            <Section
                sectionType={FilterSections.TYRE_RATINGS_VIEW}
                sectionName="tyre_ratings"
                openView={props.openView}
                translationKey={FilterSectionLabelTranslationKeys[FilterSections.TYRE_RATINGS_VIEW]}
            />

            <Section
                sectionType={FilterSections.SEASON_VIEW}
                sectionName="season"
                openView={props.openView}
                translationKey={FilterSectionLabelTranslationKeys[FilterSections.SEASON_VIEW]}
            />

            <Section
                sectionType={FilterSections.EV_VIEW}
                sectionName="ev"
                openView={props.openView}
                translationKey={FilterSectionLabelTranslationKeys[FilterSections.EV_VIEW]}
            />

            <Section
                sectionType={FilterSections.TECHNOLOGY_VIEW}
                sectionName="technology"
                openView={props.openView}
                translationKey={FilterSectionLabelTranslationKeys[FilterSections.TECHNOLOGY_VIEW]}
            />

            <Section
                sectionType={FilterSections.USAGE_VIEW}
                sectionName="usage"
                openView={props.openView}
                translationKey={FilterSectionLabelTranslationKeys[FilterSections.USAGE_VIEW]}
            />

            <Section
                sectionType={FilterSections.ADDITIONAL_VIEW}
                sectionName="additional"
                openView={props.openView}
                translationKey={FilterSectionLabelTranslationKeys[FilterSections.ADDITIONAL_VIEW]}
            />
        </LightboxOverview>

    );
}

LightboxOverviewTyre.propTypes = {
    displayDimensions: PropTypes.string,
    openView: PropTypes.func.isRequired,
    onApplyClick: PropTypes.func.isRequired,
    onResetAndCloseClick: PropTypes.func.isRequired,
    opened: PropTypes.bool.isRequired,
    filterValues: PropTypes.object.isRequired,
    filterOptions: PropTypes.object.isRequired,
    onUnsetFilter: PropTypes.func.isRequired,
    lastUsedConfigurator: PropTypes.string,
};


LightboxOverviewTyre.defaultProps = {
    lastUsedConfigurator: '',
};

export { LightboxOverviewTyre };
